module.exports = __webpack_public_path__ + "static/media/window_plus.c0e1e039.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/window_plus.jpeg
// module id = 302
// module chunks = 0